<div class="content-box">
  <h2 class="header-major">You're on the list to try ReCog for free.</h2>
  <p>We'll email you to make sure you're among the first to learn and organize with ReCog.</p>
  <p>Ask questions and stay up to date with ReCog developments by following us on <a href="https://www.facebook.com/ReCogApp/" target="_blank">Facebook</a> or <a href="https://twitter.com/ReCog_app" target="_blank">Twitter</a>.</p>
</div>

